import { ElOption, ElSelect } from "element-plus";
import { defineComponent } from "vue";
import type { ExtractPropTypes, Prop } from "vue";
import GetOptionsHoc from "../../QuickForm/src/GetOptionsHoc";
import type { ComponentPropsType } from "../../QuickForm/src/GetOptionsHoc";
const { component, props } = GetOptionsHoc(
  ElSelect as any,
  ElSelect.props as ComponentPropsType,
  ElOption as any,
  (res: any) => {
    return {
      props: res,
    };
  }
);
export type SelectExtendPropsType = ExtractPropTypes<typeof props> &
  ExtractPropTypes<typeof ElSelect.props>;
const SelectExtend = defineComponent({
  name: "SelectExtend",
  // emits: ["update:modelValue", "change"],
  ...component,
  props: props as SelectExtendPropsType,
});

export default SelectExtend;
